// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import Sidebar from './components/Sidebar';
import Login from './pages/Auth/Login';
//import Register from './pages/Auth/Register';
import Dashboard from './pages/Dashboard/Dashboard';
import Agent from './pages/Dashboard/Agent';
import PhoneNumber from './pages/Dashboard/PhoneNumber';
import CallHistory from './pages/Dashboard/CallHistory';
import PrivateRoute from './utils/PrivateRoute';

const App = () => {
  return (
    <Router>
      <Box sx={{ display: 'flex' }}>
        <Sidebar />
        <Container sx={{ marginLeft: '240px', padding: '20px' }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/agent" element={<PrivateRoute><Agent /></PrivateRoute>} />
            <Route path="/phone-numbers" element={<PrivateRoute><PhoneNumber /></PrivateRoute>} />
            <Route path="/call-history" element={<PrivateRoute><CallHistory /></PrivateRoute>} />
          </Routes>
        </Container>
      </Box>
    </Router>
  );
};

export default App;